import React from 'react'
import SarasPopup from '../../library/container/popup/SarasPopup'
import SarasTrans from '../../library/notifications/SarasTrans'
import {Info} from '../../library/decor/SarasIcons';
import FormROValue from '../../library/form/components/FormROValue1';

const DocAdminInfo = (props) => {
    const {formObject, headerKey} = props;
    const [popupName, setPopupName] = React.useState("");

    const showAdminInfoRef = React.useRef(null);

    const showHidePopup = (popupKey) => {
        setPopupName(popupKey);
    }

    return (
        <>
            <div ref={showAdminInfoRef} className="uiSpacerH10"
                onMouseEnter={() => {showHidePopup("adminInfo")}}
                onMouseLeave={() => {showHidePopup("")}}
            >
                <Info className='uiLink uiIcon'/>
           </div>
            {
            popupName ? 
                <SarasPopup anchorRef={showAdminInfoRef} open={true} >
                    <div className="uiBox uiPadding10" style={{width:"250px", height:"120px"}}>
                        <div className="uiHighlightKey uiBold"><SarasTrans value="Admin Info" /></div>
                        <ul>
                            <li>
                                <span className="uiLblS">
                                    <SarasTrans value="Created By" />
                                </span>
                                <FormROValue format="#" formObject={formObject} headerKey={headerKey} action={{ paramName: "admiCreatedBy" }} className='uiSpacerH10'/>
                            </li>
                            <li>
                                <span className="uiLblS">
                                    <SarasTrans value="Created On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} headerKey={headerKey} action={{ paramName: "admiCreatedOn" }} className='uiSpacerH10'/>
                            </li>
                            <li>
                                <span className="uiLblS">
                                    <SarasTrans value="Updated By" />
                                </span>
                                <FormROValue format="#" formObject={formObject} headerKey={headerKey} action={{ paramName: "admiUpdatedBy" }} className='uiSpacerH10'/>
                            </li>
                            <li>
                                <span className="uiLblS">
                                    <SarasTrans value="Updated On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} headerKey={headerKey} action={{ paramName: "admiUpdatedOn" }} className='uiSpacerH10'/>
                            </li>
                        </ul>
                    </div>
                </SarasPopup>
                : null}
        </>
    )
}

export default DocAdminInfo
